import React, { Fragment } from 'react';
import MenuCreateFromView from '../../../components/application/create/MenuCreateFromView';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';

const SubSubMenuCreateView = () => {
    const { data, loading, error } = useFetchData(AppURL.ApplicationURL + 'app/menu/create/view/'); // Pass only the URL
    return (
        <Fragment>
            <MenuCreateFromView data={data} loading={loading} />
        </Fragment>
    )
}

export default SubSubMenuCreateView